
(function () {
  const colorNames = [
    "color", "colour", "renk"
  ];

  function formatColor(text) {
    return text.toLocaleLowerCase("en-US")
      .replace(/\b[a-z]/g, c => c.toUpperCase());
  }

  function fixColors() {
    document.querySelectorAll(
      '[data-select-label], .selector-wrapper, .product__block--variants'
    ).forEach(group => {
      const name = (
        group.getAttribute("data-select-label") ||
        group.querySelector(".radio__legend__label")?.textContent ||
        ""
      ).trim().toLowerCase();

      if (!colorNames.includes(name)) return;

      group.querySelectorAll(
        '[data-option-value], .radio__legend__value, .radio__inputs label, .radio__buttons label'
      ).forEach(el => {
        if (el.children.length) return;

        const original = el.textContent.trim();
        const formatted = formatColor(original);

        if (original && original !== formatted) {
          el.textContent = formatted;
        }
      });
    });
  }

  function start() {
    fixColors();

    new MutationObserver(fixColors).observe(
      document.body,
      { childList: true, subtree: true, characterData: true }
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();


document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-option-value]").forEach(el => {
    if (el.textContent.trim().toUpperCase() === "ONE SIZE") {
      el.textContent = "One Size";
      el.style.textTransform = "none";
    }
  });
});
